import React from 'react';
import clsx from 'clsx';
import {
  Collapse,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import AddIcon from '@mui/icons-material/Add';
import BarChartIcon from '@mui/icons-material/BarChart';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import StoreIcon from '@mui/icons-material/Store';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import MenuIcon from '@mui/icons-material/Menu';

import { useAppDispatch, useAppSelector } from '../../hooks';
import { toggle } from '../../slices/drawerSlice';

import useStyles from '../../useStyles';



const useStylesLocal = makeStyles((theme) => ({
  nested: {
    paddingLeft: theme.spacing(2.5),
  },
}));


export default function DrawerMenu() {
  const classes = useStyles();
  const classesLocal = useStylesLocal();
  const [openVezo, setOpenVezo] = React.useState(false);


  const dispatch = useAppDispatch();
  const drawerOpen = useAppSelector(state => state.drawer.open);
  const toggleOpen = () => { dispatch(toggle()) };

  const stores = sessionStorage.getItem('stores') ? JSON.parse(sessionStorage.getItem('stores')!) : [];
  const available_services = stores.reduce((services, store) => {
    store.store_services.forEach(service => {
      if (!services.includes(service)) {
        services.push(service)
      }
    });
    return services;
  }, []);

  const handleClick = () => {
    setOpenVezo(!openVezo);
  };



  return (
    <Drawer
      variant="permanent"
      classes={{
        paper: clsx(classes.drawerPaper, !drawerOpen && classes.drawerPaperClose),
      }}
      open={drawerOpen}
    >
      <div className={classes.toolbarIcon}>
        <IconButton onClick={toggleOpen} size="large">
          {drawerOpen ? <ChevronLeftIcon /> : <MenuIcon />}
        </IconButton>
      </div>
      <Divider />
      <List>
        {available_services.includes(7) &&
          <>
            <ListItem button onClick={handleClick}>
              <ListItemIcon>
                <StarBorderIcon />
              </ListItemIcon>
              <ListItemText primary="Vezo" />
              {openVezo ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openVezo} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem button component="a" className={classesLocal.nested} href={"/vezo/storeinfo"}>
                  <ListItemIcon>
                    <StoreIcon />
                  </ListItemIcon>
                  <ListItemText primary="Informações por loja" />
                </ListItem>
                <ListItem button component="a" className={classesLocal.nested} href={"/vezo/histdata"}>
                  <ListItemIcon>
                    <BarChartIcon />
                  </ListItemIcon>
                  <ListItemText primary="Dados Históricos" />
                </ListItem>
                <ListItem button component="a" className={classesLocal.nested} href={"/vezo/ranking"}>
                  <ListItemIcon>
                    <EmojiEventsIcon />
                  </ListItemIcon>
                  <ListItemText primary="Ranking" />
                </ListItem>
                <ListItem button component="a" className={classesLocal.nested} href={"/vezo/lastevents"}>
                  <ListItemIcon>
                    <FormatListBulletedIcon />
                  </ListItemIcon>
                  <ListItemText primary="Últimos eventos" />
                </ListItem>
                <ListItem button component="a" className={classesLocal.nested} href={"/vezo/addinfo"}>
                  <ListItemIcon>
                    <AddIcon />
                  </ListItemIcon>
                  <ListItemText primary="Adicionar informação" />
                </ListItem>
              </List>
            </Collapse>
          </>
        }
      </List>
      <Divider />
    </Drawer>
  );
}

